<script lang="ts">
import { getContext } from 'svelte'

import Linkifier from '@/components/Linkifier.svelte'
import { testIds } from '@/constants'
import { contentListItemKey, type WritableMessageContext } from '@/modules/messages'

import Message from './Message.svelte'
import MessageAttachments from './MessageAttachments.svelte'
import MessageContent from './MessageContent.svelte'
import MessageDateTooltip from './MessageDateTooltip.svelte'
import MessageInfo from './MessageInfo.svelte'
import MessageText from './MessageText.svelte'

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let {
	message: { id, content, createdAt },
} = $derived($context)
</script>

{#if content.text}
	<Message testId={testIds.messageAgent}>
		<MessageDateTooltip {createdAt}>
			<MessageContent>
				<MessageText>
					<Linkifier text={content.text} />
				</MessageText>
			</MessageContent>
		</MessageDateTooltip>
		<MessageInfo {id} {createdAt} />
	</Message>
{/if}
<MessageAttachments />
